import Account from '../../common/account/account';


class FrontendAccount extends Account {

}


export default FrontendAccount;
